// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ICjO","questions":"styles_questions__1AZfn","footer":"styles_footer__8pXPn"};